export const PERSONALIZED_HOMEPAGE_CONSULTANT_PHONE_NUMBER = "48 579 779 123";

export const PERSONALIZED_HOMEPAGE_CONSULTANT_NAME = "Daniel Reinert";

export const getPersonalizedHomepageConsultantPhoneHref = (phoneNumber: string): string => `tel:+${phoneNumber.replace(/\D/g, "")}`;
export const PERSONALIZED_HOMEPAGE_CONSULTANT_PHONE_NUMBER = "48 579 779 123";

export const PERSONALIZED_HOMEPAGE_CONSULTANT_NAME = "Daniel Reinert";

export const getPersonalizedHomepageConsultantPhoneHref = (phoneNumber: string): string => `tel:+${phoneNumber.replace(/\D/g, "")}`;
